/**
 * Entfernt .preload vom Body, sobald die Seite geladen ist
 * (verhindert CSS-Animationen beim initialen Paint).
 */
export function preload() {
	const body = document.body

	if (body.classList.contains('preload')) {
		body.classList.remove('preload')
	} else {
		setTimeout(preload, 500)
	}
}
